import { TextButton } from '@app/app/_components/TextButton/TextButton';
import { ReactNode, useCallback } from 'react';

interface Props {
    stepToNavigate?: string;
    children: ReactNode;
    onClick: (stepKey: string) => void;
}

export function SummaryEditButton({ stepToNavigate, children, onClick }: Props) {
    const handleClick = useCallback(() => {
        onClick(stepToNavigate!);
    }, [onClick, stepToNavigate]);

    return (
        <TextButton preventDefault size="small" onClick={handleClick}>
            {children}
        </TextButton>
    );
}
